import classNames from 'classnames'
import React from 'react'

const PodcastDetailsLayout = ({ children, className = '' }) => {
  return (
    <div
      className={classNames(
        'relative w-full flex flex-col min-h-screen ',
        className,
      )}
    >
      {children}
    </div>
  )
}

export default PodcastDetailsLayout
